import { AxiosResponse } from 'axios'
import { User } from 'src/types/user'

import axios from '../../axios'

export const verifyEmail = async (code: string): Promise<AxiosResponse> => {
  await axios.get(`/api/csrf-cookie`)
  const response = await axios
    .post<{ user: User }>(`/api/verify-email`, {
      code,
    })
    .catch((error) => {
      return error.response
    })

  return response
}
